(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('workingTimeBox', WorkingTimeBox);

    /** @ngInject */
    function WorkingTimeBox(PATHS) {
        function WorkingTimeBoxDirectiveController($scope) {
            const vm = this;

            vm.changeOpening = time => {
                vm.workingTime.StartHourId = time.Id;
            }

            vm.changeClosing = time => {
                vm.workingTime.EndHourId = time.Id;
            }

            let removeWatchClosed = $scope.$watch('vm.isClosed', newValue => {
                vm.workingTime.Closed = vm.isClosed;

                if (newValue == true) {
                    vm.openingTime = null;
                    vm.closingTime = null;

                    vm.workingTime.StartHourId = null;
                    vm.workingTime.EndHourId = null;
                }
            });

            $scope.$on('$destroy', () => {
                removeWatchClosed();
            });

            function setWorkingTime() {
                if (!vm.workingTime) return;

                vm.openingTime = vm.hours.find(h => h.Id == vm.workingTime.StartHourId);
                vm.closingTime = vm.hours.find(h => h.Id == vm.workingTime.EndHourId);
                vm.isClosed = vm.workingTime.Closed;
            }

            function initVars() {
                if (vm.workingTime)
                    vm.isClosed = !vm.workingTime.Closed;
                else
                    vm.isClosed = false;

                vm.openingTime;
                vm.closingTime;
            }

            vm.init = () => {
                initVars();
                setWorkingTime();
            }
        }

        function link(scope, elem, attr, ctrl) {
            if (attr)
                ctrl.init();

            let removeWatchWorkingTime = scope.$watch(() => {
                return ctrl.workingTime;
            }, (newWorkTime, oldWorkTime) => {
                if (angular.equals(oldWorkTime, newWorkTime)) return;

                ctrl.init();
            });

            scope.$on('$destroy', () => {
                removeWatchWorkingTime();
            });
        }

        return {
            bindToController: true,
            controller: WorkingTimeBoxDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            link: link,
            templateUrl: `${PATHS.PHYSICAL}/directives/working-time-box/working-time-box.html`,
            scope: {
                workingTime: '=',
                weekDay: '=',
                hours: '=',
                canEdit: '='
            },
        }
    }
}());